<div class="col-12 content p-3 dHeader" >
    <div class="d-flex justify-content-between">
        <div class="lato-bold" cvLocalizedText langSection="Users" langKey="Owned_Dashboards">Owned Dashboards</div>
        <button type="button" class="btn btn-text mt-4 mb-2" (click)="openDashboardAssignModal()" *ngIf="!!dashboards && dashboards.length > 0"
                [disabled]="agGridOwned?.api?.getSelectedRows().length <= 0">
            <span cvLocalizedText langSection="Users" langKey="Change_Ownership">Change Ownership</span>
            ({{agGridOwned?.api?.getSelectedRows().length ?? 0}})
        </button>
    </div>
    <div style="margin-top:32px" *ngIf="!!dashboards && dashboards.length <= 0"
         cvLocalizedText langSection="Users" langKey="No_Owned_Dashboards">No Owned Dashboards</div>
    <div class="ownedDBDiv" *ngIf="!!dashboards && dashboards?.length > 0">
        <ag-grid-angular #dashboardsUserAdminOwnedGrid class="ag-theme-balham w-100 ownedDBGrid" [gridOptions]="gridOptionsDashboards"></ag-grid-angular>
    </div>
    <cv-loader [size]="'large'" [overlay]="false" *ngIf="!dashboards"></cv-loader>
</div>
<div class="w-100 h-100 fixed-top bg-whaleTail" style="opacity:0.6; z-index:1600" (click)="closeDashboardAssignModal()"
     [hidden]="!ownershipPopupOpen"></div>
<div class="bg-white rounded shadow mx-auto position-fixed" style="width:500px; top:50%; left:50%; transform:translate(-50%,-50%);
        padding:20px 24px 78px; z-index:1601" *ngIf="ownershipPopupOpen">
    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail position-absolute"
            style="top:12px; right:4px; line-height:0px" (click)="closeDashboardAssignModal()">
        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
    </button>
    <div class="font-size-20 pb-3 border-bottom mb-3" cvLocalizedText langSection="Users" langKey="Change_Dashboard_Ownership">
        Change Dashboard Ownership
    </div>
    <div class="lato-bold font-size-18 mb-3" cvLocalizedText langSection="Users" langKey="Dashboards_Selected">Dashboards Selected</div>
    <ng-container *ngIf="gridModalReady">
        <ag-grid-angular #dashboardsUserAdminSelectedGrid class="ag-theme-balham w-100" style="height:128px;" [gridOptions]="gridOptionsDashboardsSelected"></ag-grid-angular>
    </ng-container>
    <div class="lato-bold font-size-18" style="margin-top:36px; margin-bottom:12px" cvLocalizedText langSection="Users"
         langKey="Assign_New_Ownership">Assign New Ownership</div>
    <div class="color-valyrianSteel" style="margin-bottom:12px" cvLocalizedText langSection="Users" langKey="Assign_New_Ownership_Message">
        Only users that associate with the same linked data group as the owner of the dashboard will appear as options for a new owner.
        For all dashboards above, management of shares and subscriptions will be inherited by the new owner.
    </div>
    <div class="search-box live-search mb-2" style="width:235px">
        <input type="search" class="form-control form-control-sm" cvLocalizedPlaceholder langSection="Common" langKey="Search"
               placeholder="Search" [(ngModel)]="filterValue" (ngModelChangeDebounced)="applyFilter()" />
        <span class="clear-input" [hidden]="filterValue.length <= 0" (click)="filterValue = ''; applyFilter()"></span>
    </div>
    <ng-container *ngIf="gridModalReady">
        <ag-grid-angular #dashboardsUserAdminAssignedGrid class="ag-theme-balham w-100" style="height:176px;" [gridOptions]="gridOptionsDashboardsAssign"></ag-grid-angular>
    </ng-container>
    <div class="d-flex justify-content-end position-absolute border-top pt-3" style="bottom:14px; right:32px; width:calc(100% - 64px)">
        <button type="button" class="btn btn-text mr-2" (click)="closeDashboardAssignModal()" cvLocalizedText langSection="Common"
                langKey="Cancel_Button">
            Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="changeOwnership()"
                [disabled]="!agGridAssigned?.api || agGridAssigned?.api?.getSelectedRows().length <= 0">
            <span cvLocalizedText langSection="Users" langKey="Change_Ownership">Change Ownership</span>
            ({{agGridAssigned?.api?.getSelectedRows().length ?? 0}})
        </button>
    </div>
</div>
<div class="color-white bg-whaleTail rounded shadow position-fixed px-3" style="height:40px; right:35px; bottom:27px; padding-top:12px; padding-bottom:12px"
     *ngIf="changeOwnershipSuccessful || changeOwnershipFailed">
    <div class="d-flex justify-content-between align-items-center mb-1">
        <div class="lato-bold mr-4" [hidden]="!changeOwnershipSuccessful">
            <span cvLocalizedText langSection="Users" langKey="Change_Ownership_Success">Ownership has successfully been given to</span>
            {{pendingOwnershipChangeName}}
        </div>
        <div class="lato-bold mr-4" [hidden]="!changeOwnershipFailed" cvLocalizedText langSection="Users" langKey="Change_Ownership_Failed">
            Ownership transfer failed
        </div>
        <svg class="icon-16 fill-valyrianSteel clickable" (click)="changeOwnershipSuccessful = false; changeOwnershipFailed = false;">
            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
        </svg>
    </div>
</div>
